var _defs, _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "card",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_12",
    "data-name": "Rect\\xE1ngulo 12",
    width: 20.381,
    height: 14.22,
    transform: "translate(0 0)",
    fill: "none"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_26",
    "data-name": "Rect\\xE1ngulo 26",
    width: 24,
    height: 24,
    fill: "#1c1c1c",
    opacity: 0
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_23",
    "data-name": "Grupo 23",
    transform: "translate(2 5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_22",
    "data-name": "Grupo 22",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_19",
    "data-name": "Trazado 19",
    d: "M17.631,0H2.75A2.754,2.754,0,0,0,0,2.75v8.72a2.753,2.753,0,0,0,2.75,2.75H17.631a2.752,2.752,0,0,0,2.75-2.75V2.75A2.753,2.753,0,0,0,17.631,0m1.25,5v6.47a1.251,1.251,0,0,1-1.25,1.25H2.75A1.251,1.251,0,0,1,1.5,11.47V5Zm0-2.25V3H1.5V2.75A1.252,1.252,0,0,1,2.75,1.5H17.631a1.252,1.252,0,0,1,1.25,1.25",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_20",
    "data-name": "Trazado 20",
    d: "M3.254,9.357h3a.5.5,0,0,0,0-1h-3a.5.5,0,0,0,0,1",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_21",
    "data-name": "Trazado 21",
    d: "M10.625,9.36h6.5a.5.5,0,0,0,0-1h-6.5a.5.5,0,0,0,0,1",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard);
export default __webpack_public_path__ + "static/media/card.cb86950906f87a9f5358d28f14d5e3ec.svg";
export { ForwardRef as ReactComponent };